import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Loader, Message } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import LaunchContextService from '../services/LaunchContextService';

export default
@inject('contentManager', 'userManager')
@observer
class DocReaderLaunch extends Component {
  constructor(props) {
    super(props);

    this.DocReaderModal = SatCoreComponent('DocReaderModal');
    this.state = {
      error: null,
      fallbackRoute: '/',
      isLoading: true,
      modalState: null
    };
  }

  componentDidMount() {
    this.bootstrapLaunchContext();
  }

  bootstrapLaunchContext = () => {
    const { location, contentManager } = this.props;
    const params = new URLSearchParams(location?.search);
    const launchId = params.get('docReaderLaunchId');

    if (!launchId) {
      this.setState({
        error: 'Missing docReaderLaunchId parameter. Please restart the launch workflow.',
        isLoading: false
      });
      return;
    }

    const context = LaunchContextService.consumeContext(launchId);
    if (!context || !context.docReaderUrl) {
      this.setState({
        error: 'Launch information has expired. Please retry from the original tab.',
        isLoading: false
      });
      return;
    }

    if (context.docReaderUrl) {
      contentManager.setDocReaderUrl(context.docReaderUrl);
    }
    if (context.modalState?.sessionId) {
      contentManager.setCurrentFlowPaperSessionId(context.modalState.sessionId);
    }

    this.setState({
      fallbackRoute: context.meta?.sourceRoute || '/',
      isLoading: false,
      modalState: context.modalState || {}
    });
  }

  handleClose = () => {
    const { history, location } = this.props;
    const { fallbackRoute } = this.state;
    const params = new URLSearchParams(location?.search);
    const launchedViaParam = params.has('docReaderLaunchId');

    if (launchedViaParam) {
      window.close();
      return;
    }

    if (window.opener) {
      window.close();
      return;
    }

    history.replace(fallbackRoute || '/');
  }

  renderError = () => {
    const { error } = this.state;
    return (
      <Message
        content={error || 'Unable to load DocReader assignment.'}
        negative />
    );
  }

  render() {
    const { DocReaderModal } = this;
    const { userManager } = this.props;
    const { error, isLoading, modalState } = this.state;

    if (isLoading) {
      return (
        <div className='docreader-launch-loading'>
          <Loader active inline='centered' size='large'>Preparing DocReader…</Loader>
        </div>
      );
    }

    if (error || !modalState) {
      return this.renderError();
    }

    return (
      <div className='docreader-launch-container'>
        <DocReaderModal
          assignmentId={modalState.assignmentId}
          closeModalCallback={this.handleClose}
          contentImageUrl={modalState.contentImageUrl}
          contentMode={modalState.contentMode}
          contentName={modalState.contentName}
          contentType={modalState.previewContentType}
          grade={modalState.grade}
          instruction={modalState.instruction}
          isFlowpaper={modalState.isFlowpaper}
          isTeacher={userManager.isTeacher}
          maxScore={modalState.maxScore}
          page='docreader-viewer'
          resourceName={modalState.resourceName}
          sessionId={modalState.sessionId}
          studentName={modalState.studentName}
          totalScore={modalState.totalScore} />
      </div>
    );
  }
}

SatCoreRegister('DocReaderLaunch', DocReaderLaunch);
